import ApiUtils from "../utils/ApiUtils"
import IDishCatalogueResponse from "../models/maverick/IDishCatalogueResponse";
import {MAVERICK_API_PREFIX} from "../../../common/configs/configs";
import {IMaverickApis} from "./IMaverickApis";
import IInterventionCatalogueResponse from "../models/maverick/IInterventionsCatalogueResponse";

const dietGuidelineCategory = "$dietGuidelineCategory";

const fetchDishesByDishNameUrl: string = MAVERICK_API_PREFIX + "/dish/dish_catalogue?q=";
const fetchDietGuidelinesByCategory: string = MAVERICK_API_PREFIX + "/care/guideline_catalogue?action=$dietGuidelineCategory&q=";
const fetchMindfulnessActivitiesUrl: string = MAVERICK_API_PREFIX + "/mind/mind_tag_catalogue/?q="
const fetchCommonInterventionsUrl: string = MAVERICK_API_PREFIX + "/care/intervention_catalogue?"

export default class MaverickApis implements IMaverickApis {
    getDishByDishName(input: string): Promise<IDishCatalogueResponse[]> {
        return ApiUtils.apiGetRequest(fetchDishesByDishNameUrl + encodeURIComponent(input));
    }
    getDietGuidelinesByCategory(input: string, category: string): Promise<IDishCatalogueResponse[]> {
        return ApiUtils.apiGetRequest(fetchDietGuidelinesByCategory.replace(dietGuidelineCategory, category) + input);
    }
    getMindfulnessActivities(input: string): Promise<any[]> {
        return ApiUtils.apiGetRequest(fetchMindfulnessActivitiesUrl + input);
    }
    getCommonInterventions( input: string, resultSize:number = 20) : Promise<IInterventionCatalogueResponse[]>{
        return ApiUtils.apiGetRequest(fetchCommonInterventionsUrl+`result-size=${resultSize}&q=${input}&utm_source=ORION`);
    }
}